import { render } from "./v-label.vue?vue&type=template&id=389de2f2&lang=true"
import script from "./v-label.vue?vue&type=script&lang=js"
export * from "./v-label.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__